
    // Function to format dates as "Sep 3"
    let intervalIdQv;
    let todayDateOrderNowQv = "";

    let ntoOrderReadyDateToQv = "";
    let ntOrderReadyDateFromQv = "";

    let ntOrderDeliveryDateToQv = "";
    let ntOrderDeliveryDateFromQv = "";

    let setDeliveryToCartQv = "";

    let isRushOrderQv = false;
    let isExpressShippingQv = false;

    let isRingQv = false;
    let isBraceletQv = false;
    let isEarringQv = false;
    let isPendantQv = false;
    let isWatchesQv = false;
    
    
    let orderReadyHolidayToQv = 20;

    let orderReadyRegulerToQv = 9;
    let orderReadyRegulerFromQv = 11;

    let orderReadyToQv = 9;
    let orderReadyFromQv = 11;

    let orderDeliveryToQv = 14;
    let orderDeliveryFromQv = 22;

    document.addEventListener('DOMContentLoaded', function() {
        const observerQv = new MutationObserver((mutations) => {
            mutations.forEach(mutation => {
                if (mutation.addedNodes.length) {
                  
                    const rushOrderQv = document.getElementById('Yes RO-0');
                    const expressShippingQv = document.getElementById('Yes ES-0');

                    if (rushOrderQv) {
                        rushOrderQv.addEventListener('change', function() {
                            isRushOrderQv = rushOrderQv.checked;
                            updateDeliveryTimeOnRushQv(isRushOrderQv,isExpressShippingQv);
                        });
                    }

                    if (expressShippingQv) {
                        expressShippingQv.addEventListener('change', function() {
                            isExpressShippingQv = expressShippingQv.checked;
                            updateDeliveryTimeOnRushQv(isRushOrderQv,isExpressShippingQv);
                        });
                    }
                }
            });
        });
        // Observe the document body or a specific container
        observerQv.observe(document.body, { childList: true, subtree: true });
    });

    function updateDeliveryTimeOnRushQv(isRushOrderQv, isExpressShippingQv) {
        if(isRingQv || isEarringQv || isPendantQv){
            if(isRushOrderQv && isExpressShippingQv){
                orderReadyToQv = 4 + orderReadyHolidayToQv;
                orderReadyFromQv = 5 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 6;
                orderDeliveryFromQv = orderReadyFromQv + 7;
            }else if(isRushOrderQv){
                orderReadyToQv = 4 + orderReadyHolidayToQv;
                orderReadyFromQv = 5 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 10;
                orderDeliveryFromQv = orderReadyFromQv + 12;
            }else if(isExpressShippingQv){
                orderReadyToQv = 9 + orderReadyHolidayToQv;
                orderReadyFromQv = 11 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 6;
                orderDeliveryFromQv = orderReadyFromQv + 7;
            }else{
                orderReadyToQv = 9 + orderReadyHolidayToQv;
                orderReadyFromQv = 11 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 10;
                orderDeliveryFromQv = orderReadyFromQv + 12;
            }
        }else if(isWatchesQv){
            if(isRushOrderQv && isExpressShippingQv){
                orderReadyToQv = 7 + orderReadyHolidayToQv;
                orderReadyFromQv = 8 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 6;
                orderDeliveryFromQv = orderReadyFromQv + 7;
            }else if(isRushOrderQv){
                orderReadyToQv = 7 + orderReadyHolidayToQv;
                orderReadyFromQv = 8 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 10;
                orderDeliveryFromQv = orderReadyFromQv + 12;
            }else if(isExpressShippingQv){
                orderReadyToQv = 9 + orderReadyHolidayToQv;
                orderReadyFromQv = 11 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 6;
                orderDeliveryFromQv = orderReadyFromQv + 7;
            }else{
                orderReadyToQv = 9 + orderReadyHolidayToQv;
                orderReadyFromQv = 11 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 10;
                orderDeliveryFromQv = orderReadyFromQv + 12;
            }
        }else if(isBraceletQv){
            if(isExpressShippingQv){
                orderReadyToQv = 9 + orderReadyHolidayToQv;
                orderReadyFromQv = 11 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 6;
                orderDeliveryFromQv = orderReadyFromQv + 7;
            }else{
                orderReadyToQv = 9 + orderReadyHolidayToQv;
                orderReadyFromQv = 11 + orderReadyHolidayToQv;
                orderDeliveryToQv = orderReadyToQv + 10;
                orderDeliveryFromQv = orderReadyFromQv + 12;
            }
        }
        else{
            orderReadyToQv = 9 + orderReadyHolidayToQv;
            orderReadyFromQv = 11 + orderReadyHolidayToQv;
            orderDeliveryToQv = orderReadyToQv + 10;
            orderDeliveryFromQv = orderReadyFromQv + 12;
        }
    }

   function updateDeliveryOnType(readyTo, readyFrom, deliveryTo, DeliveryFrom){
            orderReadyToQv = readyTo;
            orderReadyFromQv = readyFrom;
            orderDeliveryToQv = deliveryTo;
            orderDeliveryFromQv = DeliveryFrom;
    }

    function formatDateQv(date) {
        const options = { month: 'short', day: '2-digit' };
        return new Intl.DateTimeFormat('en-US', options).format(date);
    }

    // Function to format time as "HH:MM:SS"
    function formatTimeQv(milliseconds) {
        const hours = Math.floor((milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((milliseconds % (1000 * 60 * 60)) / (1000 * 60));
        return `${String(hours).padStart(2, '0')}Hours ${String(minutes).padStart(2, '0')}Minutes`;
    }

    // Function to update static elements
    function updateElementsQv() {
        const today = new Date();
        const dayOfWeek = today.getDay(); 

        // Check if current time is before or after noon
        const isBeforeNoon = today.getHours() < 12;

        // Adjust start date based on whether it's before or after noon
        const startDate = new Date(today);
        if (!isBeforeNoon) {
            // If time is 12:00 or later, start counting from the next day
            startDate.setDate(today.getDate() + 1);
        }

        // Calculate order ready dates
        const orderReadyDateTo = new Date(startDate);
        orderReadyDateTo.setDate(startDate.getDate() + orderReadyToQv);

        const orderReadyDateFrom = new Date(startDate);
        orderReadyDateFrom.setDate(startDate.getDate() + orderReadyFromQv);

        // Calculate delivery dates
        const deliveryOffset = dayOfWeek === 0 ? 1 : 0;

        const orderDeliveryDateTo = new Date(startDate);
        for (let i = 0; i < orderDeliveryToQv + deliveryOffset; i++) {
            orderDeliveryDateTo.setDate(orderDeliveryDateTo.getDate() + 1);
            while (orderDeliveryDateTo.getDay() === 0) { 
                orderDeliveryDateTo.setDate(orderDeliveryDateTo.getDate() + 1);
            }
        }

        const orderDeliveryDateFrom = new Date(startDate);
        for (let i = 0; i < orderDeliveryFromQv + deliveryOffset; i++) {
            orderDeliveryDateFrom.setDate(orderDeliveryDateFrom.getDate() + 1);
            while (orderDeliveryDateFrom.getDay() === 0) { 
                orderDeliveryDateFrom.setDate(orderDeliveryDateFrom.getDate() + 1);
            }
        }

        todayDateOrderNowQv = today;
        ntoOrderReadyDateToQv = orderReadyDateTo;
        ntOrderReadyDateFromQv = orderReadyDateFrom;
        ntOrderDeliveryDateToQv = orderDeliveryDateTo;
        ntOrderDeliveryDateFromQv = orderDeliveryDateFrom;

        // Format dates
        const formattedToday = formatDateQv(today);
        const formattedReady = formatDateQv(orderReadyDateTo) + " - " + formatDateQv(orderReadyDateFrom);
        const formattedDelivery = formatDateQv(orderDeliveryDateTo) + " - " + formatDateQv(orderDeliveryDateFrom);

        document.getElementById('deliveryTodayOrderDateQv').innerHTML = formattedToday;
        document.getElementById('deliveryReadyOrderDateQv').innerHTML = formattedReady;
        document.getElementById('deliveryOrderDateQv').innerHTML = formattedDelivery;

        // original
        // if (setDeliveryToCartQv === "") {
        //     setDeliveryToCartQv = formatDateQv(orderDeliveryDateTo) + " and " + formatDateQv(orderDeliveryDateFrom);
        //     document.getElementById('deliveryHiddenDate').value = setDeliveryToCartQv;
        // }
    }

    // Function to calculate and update the cutoff time
    function updateCutoffTimeQv() {
        const now = new Date();
        const cutoffTime = new Date();

        // Set cutoff time to 12:00 noon today
        cutoffTime.setHours(12, 0, 0, 0);

        // Check if current time is past the cutoff time
        if (now > cutoffTime) {
            cutoffTime.setDate(cutoffTime.getDate() + 1); // Set to the next day if past 12:00 noon
        }

        const timeDiff = cutoffTime - now;
        const formattedTimeLeft = formatTimeQv(timeDiff);

        const formattedDelivery = formatDateQv(ntOrderDeliveryDateToQv) + " - " + formatDateQv(ntOrderDeliveryDateFromQv);

        // Display the countdown
        document.querySelector(".cutoff-time-qv").innerHTML = `${formattedTimeLeft}`;
        document.querySelector(".d-date-time-qv").innerHTML = formattedDelivery;

        // Update elements and countdown timer immediately
        updateElementsQv();
    }

    // Set up interval
    function startIntervalQv() {
        if (!intervalIdQv) { // Prevent multiple intervals
            intervalIdQv = setInterval(updateCutoffTimeQv, 1000); // Update cutoff time every second
            console.log("Interval started ........");
        }
    }

    function clearUpdateIntervalQv() {
        if (intervalIdQv) {
            clearInterval(intervalIdQv);
            intervalIdQv = null;
            console.log("Interval cleared");
        }
    }

    function setProductType(){
      const quickviewWrappers = document.querySelectorAll('.quickshop-product');

        quickviewWrappers.forEach(wrapper => {
            const productType = wrapper.getAttribute('data-product-type');
            console.log('Product Type -------:', productType); // Check if the value is correct

            // Perform actions based on the product type
            if (productType === 'Rings') {
                isRingQv = true;
            } else if (productType === 'Bracelet') {
                isBraceletQv = true;
            } else if (productType === 'Earring') {
                isEarringQv = true;
            } else if (productType === 'Pendant') {
                isPendantQv = true;
            } else if (productType === 'Watches') {
                isWatchesQv = true;
            }
        });
    }


    // Add event listener to the button
        // Create an IntersectionObserver instance
        const observers = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // If the div is visible, start the interval
                    startIntervalQv();
                    setProductType();
                } else {
                    // If the div is not visible, clear the interval
                    clearUpdateIntervalQv();
                }
            });
        }, {
            threshold: 0.1 // Adjust the threshold as needed
        });

        // Target the element
        const targetElement = document.querySelector('.product-quickview__container');
        if (targetElement) {
            observers.observe(targetElement);
        }

    // Optional: Clear interval on page unload
    window.addEventListener('beforeunload', clearUpdateIntervalQv);
